import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import Loader from "../components-legacy/Loader.jsx"
import { StrategyAIBuilder } from "./strategy-ai/StrategyAIBuilder.jsx"
import { server } from "./chat/Server.js"

export function Strategy() {
  const { sid } = useParams()
  const [processing, setProcessing] = useState(true)
  const [error, setError] = useState('')
  const [data, setData] = useState(null)

  useEffect(() => {
   server.api(`strategy/details`, { strId: sid }).then(res => {
      setProcessing(false)
      setData(res.main)
    }).catch(err => {
      setProcessing(false)
      if (err.errorCode === 'STRATEGY_NOT_FOUND' || err.errorCode === 'STRATEGY_NOT_ACTIVE') {
        setError('Strategy not found.')
      } else {
        setError('An error occurred. Please try again.')
      }
    })
  }, [sid])

  if (error) {
    return <div className='container pad px-4 py-6 text-foreground'>{error}</div>
  }

  if (processing) {
    return <Loader />
  }

  if (data !== null) {
    return <StrategyAIBuilder sid={sid} data={data} />
  }

}

